import React from 'react';
import PropTypes from 'prop-types';

import { Spacer, Text } from '@zillow/constellation';

import { StyledFullWidthButton } from '../../StyledComponents';
import { StyledText, StyledSuccessIcon } from './StyledComponents';

const propTypes = {
    showVerificationModal: PropTypes.func.isRequired,
};

const Finished = ({ showVerificationModal, verificationSuccessfulCTAText }) => (
    <div>
        <StyledSuccessIcon size="lg" />
        <Text fontType="bodyheading">
            Success!
        </Text>
        <StyledText as="div">
            Your number has been verified. You&#39;re done.
        </StyledText>
        <Spacer marginTop="sm">
            <StyledFullWidthButton
                buttonType="primary"
                onClick={() => showVerificationModal(false)}
            >
                {verificationSuccessfulCTAText}
            </StyledFullWidthButton>
        </Spacer>
    </div>
);

Finished.propTypes = propTypes;

export default Finished;
